import React from 'react';

// eslint-disable-next-line react/prop-types
const normalize = func => Component => ({ data, ...rest }) => (
  <Component data={func(data)} {...rest} />
);

export default normalize;
